import { ReactNode } from "react";

export type AlignmentViewData = {
  columns?: Array<{
    value: string;
    label: string;
  }>;
  sections?: AlignmentViewSectionData[];
};

export type AlignmentViewSectionData = {
  id: string;
  title: string;
  header: ReactNode;
  rows?: AlignmentViewRowData[];
};

export type AlignmentViewRowData = {
  id: string;
  cells?: AlignmentViewCellData[];
};

export type AlignmentViewCellData = {
  contents: ReactNode;
  matchesFilter: (filterText: string) => boolean;
};

export type AlignmentViewVisibility = {
  sections: AlignmentViewSectionVisibility[];
};

export type AlignmentViewSectionVisibility = {
  isVisible: boolean;
  rows: AlignmentViewRowVisibility[];
};

export type AlignmentViewRowVisibility = {
  isVisible: boolean;
  cells: AlignmentViewCellVisibility[];
};

export type AlignmentViewCellVisibility = {
  isMuted: boolean;
  isEmpty: boolean;
  isVisible: boolean;
  isSelected: boolean;
};

export const computeVisibility = (
  data: AlignmentViewData | undefined,
  visibleColumnIndexes: number[],
  selectedColumnIndexes: number[],
  filterText: string,
): AlignmentViewVisibility => {
  const result: AlignmentViewVisibility = { sections: [] };
  if (data?.sections == null) return result;

  for (const section of data.sections) {
    const visSection: AlignmentViewSectionVisibility = {
      isVisible: false,
      rows: [],
    };
    result.sections.push(visSection);
    if (section.rows == null) continue;

    for (const row of section.rows) {
      const visRow: AlignmentViewRowVisibility = {
        isVisible: false,
        cells: [],
      };
      visSection.rows.push(visRow);
      if (row.cells == null) continue;

      for (let i = 0; i < row.cells.length; i++) {
        const cell = row.cells[i];
        const visCell: AlignmentViewCellVisibility = {
          isEmpty: !cell.contents,
          isMuted: !cell.matchesFilter(filterText),
          isSelected: selectedColumnIndexes.includes(i),
          isVisible: visibleColumnIndexes.includes(i),
        };

        visRow.cells.push(visCell);
        if (visCell.isSelected && !visCell.isEmpty && !visCell.isMuted) {
          visRow.isVisible = true;
        }
      }

      if (visRow.isVisible) {
        visSection.isVisible = true;
      }
    }
  }

  return result;
};
